import { useMemo } from 'react';
import { qrShape } from '@/lib/qrModel';
import { cn } from '@/lib/utils';

/**
 * A QR code as inline SVG, generated in the browser (lib/qrModel.ts). Always black on a white tile, in both themes:
 * phone cameras read dark-on-light codes reliably, and these are not brand colors.
 */
export function QrCode({ value, label, className, testId }: { value: string; label: string; className?: string; testId?: string }) {
  const { size, path } = useMemo(() => qrShape(value), [value]);
  return (
    <svg viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label} shapeRendering="crispEdges" data-testid={testId} className={cn('block aspect-square rounded-lg', className)}>
      <rect width={size} height={size} fill="white" />
      <path d={path} fill="black" />
    </svg>
  );
}
